import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
const $ = window.jQuery;

const Nav = {
	init() {
		const $burger = $(document).find('.burger .toggle-btn');
		if (!$burger.length) return;

		const $toggleBbutton = $(document).find('.toggle-button');

		// Toggle sub-menus
		$toggleBbutton.on('click', function () {
			$(this).parent().toggleClass('menu-collapsed');
			$(this).toggleClass('tgl-active');
		});

		$burger.on('click', function () {
			$(this).toggleClass('active');
			$('nav.main ').toggleClass('mobile-active');
			var $parentsSubMenus = $('#huvudmeny').find('.current-menu-item').parents('.sub-menu');
			$parentsSubMenus.prev().toggleClass('tgl-active');
			$parentsSubMenus.parent().toggleClass('menu-collapsed');
			if ($(this).hasClass('active')) {
				disableBodyScroll($('#huvudmeny > ul')[0]);
				$(document).find('#CookiebotWidget').addClass('CookiebotWidget-inactive');
				$(document).find('#tidio-chat').hide('fast');
			} else {
				enableBodyScroll($('#huvudmeny > ul')[0]);
				$(document).find('#CookiebotWidget').removeClass('CookiebotWidget-inactive');
				$(document).find('#tidio-chat').show('fast');
			}
		});

		$(window).on('resize', function () {
			// check if windowsize is bigger than 1025px
			if ($(window).width() > 1025) {
				enableBodyScroll($('#huvudmeny > ul')[0]);
			}
		});

		const $searchToggle = $(document).find('.toggle-search');
		const $searchContainer = $(document).find('.search-wrap');

		$searchToggle.on('click', function () {
			$searchContainer.slideToggle('fast');
		});
	},
};

export default Nav;
